// src/components/Loader.js
import React from 'react';

export const Loader = ({ size = 'md', text = '' }) => {
  const sizes = { sm: 20, md: 36, lg: 56 };
  const s = sizes[size] || sizes.md;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '2rem' }}>
      <svg width={s} height={s} viewBox="0 0 50 50" style={{ animation: 'spin 0.9s linear infinite' }}>
        <circle cx="25" cy="25" r="20" fill="none" stroke="var(--dark-4)" strokeWidth="4" />
        <circle cx="25" cy="25" r="20" fill="none" stroke="var(--gold)" strokeWidth="4"
          strokeDasharray="60 200" strokeLinecap="round"
          style={{ transformOrigin: 'center', transform: 'rotate(-90deg)' }} />
      </svg>
      {text && <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', fontFamily: 'var(--font-ui)' }}>{text}</p>}
    </div>
  );
};

export const RecipeCardSkeleton = () => (
  <div className="card" style={{ overflow: 'hidden' }}>
    <div className="skeleton" style={{ height: 220, width: '100%', borderRadius: 0 }} />
    <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div className="skeleton" style={{ height: 20, width: '70%' }} />
      <div className="skeleton" style={{ height: 14, width: '45%' }} />
      <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
        <div className="skeleton" style={{ height: 24, width: 60, borderRadius: 99 }} />
        <div className="skeleton" style={{ height: 24, width: 80, borderRadius: 99 }} />
      </div>
    </div>
  </div>
);

export const PageLoader = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--dark-1)' }}>
    <div style={{ textAlign: 'center' }}>
      <img
        src="/DR-Aura SRF 1.png"
        alt="DR-Aura"
        style={{
          height: 'clamp(80px, 12vw, 120px)',
          objectFit: 'contain',
          marginBottom: '1.5rem',
          filter: 'drop-shadow(0 0 24px rgba(100,120,255,0.55)) drop-shadow(0 0 48px rgba(180,80,255,0.25))',
          animation: 'float 2s ease-in-out infinite',
        }}
      />
      <Loader size="lg" text="Loading DR-Aura…" />
    </div>
  </div>
);

export default Loader;
